import React, { useState } from 'react';
import { Viewer3D } from './components/Viewer3D';
import { NavigationControls } from './components/NavigationControls';
import { BottomPanel } from './components/BottomPanel';
import { TopPanel } from './components/TopPanel';
import { QuoteModal } from './components/QuoteModal';
import { ShoppingCart } from './components/ShoppingCart';
export function App() {
  const [totalPrice, setTotalPrice] = useState(145000);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedItem, setSelectedItem] = useState('');
  const [hoveredCategory, setHoveredCategory] = useState('');
  const [forceExpand, setForceExpand] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [shouldCollapseMenu, setShouldCollapseMenu] = useState(false);
  const [cartItems, setCartItems] = useState<Array<{
    id: string;
    name: string;
    price: number;
    category: string;
  }>>([
  // Add apartment as default first item
  {
    id: 'apartment',
    name: 'Korter',
    price: 145000,
    category: 'apartment'
  }]);
  const handleCategorySelect = (category: string) => {
    setSelectedCategory(category);
    // Automatically select first item when category is selected
    if (!selectedItem || selectedCategory !== category) {
      setSelectedItem('item1');
    }
  };
  const handleItemSelect = (item: string) => {
    setSelectedItem(item);
    // In a real implementation, this would update the 3D model
    // and recalculate the price
  };
  const handleFocusChange = (category: string, isClick: boolean = false) => {
    setHoveredCategory(category);
    // Only set selected category on click
    if (isClick && category) {
      // Use handleCategorySelect which now also selects the first item
      handleCategorySelect(category);
      // Force expand the panel (to handle cases where same category is clicked again)
      setForceExpand(true);
      // Reset the force expand flag after a short delay
      setTimeout(() => setForceExpand(false), 100);
    }
  };
  const handleNavigation = () => {
    // Signal to collapse the menu when user navigates
    setShouldCollapseMenu(true);
    // Clear category selection when navigating
    setSelectedCategory('');
    setSelectedItem('');
    // Reset the flag after a short delay
    setTimeout(() => setShouldCollapseMenu(false), 100);
  };
  const handleGetQuote = () => {
    setIsQuoteModalOpen(true);
  };
  const handleCloseQuote = () => {
    setIsQuoteModalOpen(false);
  };
  const handleAddToCart = (item: {
    id: string;
    name: string;
    price: number;
    category: string;
  }) => {
    // Check if item already exists in cart
    const exists = cartItems.some(cartItem => cartItem.id === item.id && cartItem.category === item.category);
    if (!exists) {
      setCartItems([...cartItems, item]);
      // Update total price
      setTotalPrice(prevPrice => prevPrice + item.price);
    }
  };
  const handleRemoveFromCart = (item: {
    id: string;
    name: string;
    price: number;
    category: string;
  }) => {
    // Don't allow removing the apartment
    if (item.id === 'apartment') return;
    setCartItems(cartItems.filter(cartItem => !(cartItem.id === item.id && cartItem.category === item.category)));
    // Update total price
    setTotalPrice(prevPrice => prevPrice - item.price);
  };
  const handleOpenCart = () => {
    setIsCartOpen(true);
  };
  const handleCloseCart = () => {
    setIsCartOpen(false);
  };
  return <div className="relative w-full h-screen bg-gray-100 overflow-hidden" data-id="element-0">
      {/* 3D Viewer (Main Content) */}
      <Viewer3D onFocusChange={handleFocusChange} onNavigation={handleNavigation} selectedCategory={selectedCategory} selectedItem={selectedItem} data-id="element-1" />
      {/* Navigation Controls (Overlay) */}
      <NavigationControls data-id="element-2" />
      {/* Top Panel with Price and Actions */}
      <TopPanel totalPrice={totalPrice} onGetQuote={handleGetQuote} onOpenCart={handleOpenCart} cartItemCount={cartItems.length - 1} // Subtract 1 for apartment
    data-id="element-3" />
      {/* Bottom Panel for Selections */}
      <BottomPanel selectedCategory={selectedCategory} selectedItem={selectedItem} hoveredCategory={hoveredCategory} onCategorySelect={handleCategorySelect} onItemSelect={handleItemSelect} onAddToCart={handleAddToCart} onRemoveFromCart={handleRemoveFromCart} forceExpand={forceExpand} shouldCollapse={shouldCollapseMenu} cartItems={cartItems} data-id="element-4" />
      {/* Quote Modal */}
      {isQuoteModalOpen && <QuoteModal totalPrice={totalPrice} onClose={handleCloseQuote} data-id="element-5" />}
      {/* Shopping Cart Modal */}
      {isCartOpen && <ShoppingCart items={cartItems} onClose={handleCloseCart} onRemoveItem={handleRemoveFromCart} data-id="element-6" />}
    </div>;
}